import { useState, type ReactNode } from 'react';
import { Field, ErrorMessage, type FieldInputProps } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import { FormattedMessage } from 'react-intl';
import s from './TextAreaInput.module.scss';
import InputErrorMessage from '../shared/InputErrorMessage';
import formStyles from '../../../styles/forms.module.scss';
import type { FormikTouchedErrorsForm } from '../shared/formikTypes';
import { getFieldErrorState, joinClassNames } from '../shared/formFieldUi';

interface TextAreaInputProps {
  field: FieldInputProps<string>;
  form: FormikTouchedErrorsForm;
  labelMsg?: string;
  labelClass?: string;
  labelHTML?: ReactNode;
}

function TextAreaInput({
  field,
  form,
  labelMsg,
  labelClass = '',
  labelHTML,
}: TextAreaInputProps) {
  const { value, name, onChange } = field;
  const [id] = useState(() => uuidv4());
  const { isError } = getFieldErrorState(form, name);

  const wrapperClassName = joinClassNames(
    s.textAreaInput,
    labelClass,
    isError && formStyles.errorBorder
  );

  return (
    <label htmlFor={id} className={wrapperClassName}>
      {labelHTML && (
        <>
          {' '}
          {labelHTML}
          <br />
          <br />
        </>
      )}
      {labelMsg && <FormattedMessage id={labelMsg} />}
      <Field
        component="textarea"
        id={id}
        name={name}
        className="form-control"
        onInput={onChange}
        value={value ?? ''}
      />
      <ErrorMessage name={name} component={InputErrorMessage} />
    </label>
  );
}

export default TextAreaInput;
